import { PT_HUB_ALTERNATES } from '../../../../../components/market/PtTopicPage'

// Kuala Lumpur personal trainer hub. No trainer roster (none in KL yet).
const content = {
    title: (c) => `Personal Trainer KL from ${c.money(c.lowest, 0)}/Session | Condo Gym & Home`,
    description: (c) =>
        `Certified personal trainers in Kuala Lumpur at your condo gym, home or park. Packages from ${c.money(c.lowest, 0)} a session. Female trainers on request.`,
    eyebrow: 'Kuala Lumpur',
    h1: 'Personal Trainer in Kuala Lumpur',
    heroCopy: (c) =>
        `A certified trainer in your condo gym, at home or in the park. ${c.money(c.pt('Signature', 14), 0)} a session on 14 sessions, down to ${c.money(c.lowest, 0)} on our longest package.`,
    image: 'personal-trainer/female-personal-trainer-training-girl-at-gym.jpeg',
    imageAlt: 'Personal trainer coaching a client in a condo gym',
    facts: ['Condo gym, home or park', 'Female trainers on request', 'Partner rate'],
    packagesTitle: 'Personal training packages in KL',
    packagesIntro: 'Per-session prices fall as packages get longer. Partner training splits a session between two people.',
    sections: [
        {
            title: 'Where KL clients train',
            cards: [
                { title: 'Condo gyms', body: 'Most KL condos have a gym. Your trainer meets you there - check your management\'s rules on outside trainers.' },
                { title: 'At home', body: 'Landed homes and apartments: the trainer brings bands, dumbbells and mats.' },
                { title: 'Parks', body: 'Early mornings at Bukit Kiara, Taman Tasik Titiwangsa, KLCC Park or Perdana Botanical Garden, before the heat and the afternoon rain.' },
                { title: 'Online', body: 'For outstation trips and busy weeks, a video session keeps you on track.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'Planning around KL weather and life',
            tone: 'muted',
            paragraphs: [
                'Outdoor sessions work best before 9am; afternoon thunderstorms are common for much of the year, so your trainer always has an indoor plan B. During Ramadan, sessions move to after berbuka or before sahur, at lower intensity.',
                'Office hours and KL traffic make early-morning and evening slots the most popular. Weekday daytime sessions are the cheapest - a good option for shift workers, parents and retirees.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is a personal trainer in KL?',
            answer: (c) => `With StringsSG, ${c.money(c.pt('Signature', 14), 0)} to ${c.money(c.lowest, 0)} a session for Signature trainers and ${c.money(c.pt('Elite', 14), 0)} to ${c.money(c.pt('Elite', 50), 0)} for Elite trainers, depending on package length.`,
        },
        {
            question: 'Can the trainer come to my condo gym?',
            answer: 'Yes, where management allows outside trainers. Some condos ask for the trainer\'s IC or a visitor registration.',
        },
        {
            question: 'Do you cover Petaling Jaya and Subang?',
            answer: 'Yes - KL and the nearby Klang Valley, including PJ and Subang Jaya.',
        },
    ],
    schema: { name: 'Personal Trainer in Kuala Lumpur' },
    alternates: PT_HUB_ALTERNATES,
}

export default content
